import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { isCompanyAdmin } from '../authStorage';

const ProjectListPage = () => {
  const canManageProjects = isCompanyAdmin();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');
  const [saving, setSaving] = useState(false);

  async function load() {
    setErr('');
    try {
      const res = await api.get('/projects');
      setProjects(res.data || []);
    } catch (e) {
      setErr(e.response?.data?.error || e.message || 'Không tải được danh sách dự án');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function handleAdd(e) {
    e.preventDefault();
    const n = name.trim();
    if (!n) return;
    setSaving(true);
    setErr('');
    try {
      await api.post('/projects', { name: n, description: desc.trim() || null });
      setName('');
      setDesc('');
      await load();
    } catch (e) {
      setErr(e.response?.data?.error || e.message || 'Không tạo được dự án');
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <p>Đang tải…</p>;

  return (
    <div>
      <h2>Danh sách dự án</h2>
      <p style={{ color: '#64748b', fontSize: 14, maxWidth: 640 }}>
        Mỗi công ty quản lý nhiều dự án. Trong từng dự án có nhiều <strong>đội thi công</strong> — đội import
        công việc và cập nhật % tiến độ hàng ngày.
        {!canManageProjects && (
          <>
            {' '}
            <strong>Dự án do quản trị công ty tạo</strong> — sau khi được duyệt, bạn có <strong>một đội thi công
            riêng trên mỗi dự án</strong> (tên theo email), tự làm lead; chọn dự án rồi dùng mục{' '}
            <Link to="/progress">Tiến độ</Link> để import và cập nhật %. Quản trị chỉ cần thêm bạn vào đội chung khi
            phối hợp nhóm — không bắt buộc để có đội riêng.
          </>
        )}
      </p>
      {err && <p className="page-alert page-alert--error">{err}</p>}
      {canManageProjects && (
      <form onSubmit={handleAdd} className="admin-form-add-project">
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span style={{ fontSize: 13, color: '#475569' }}>Tên dự án mới</span>
          <input
            value={name}
            onChange={(ev) => setName(ev.target.value)}
            placeholder="Ví dụ: Chung cư Bình Minh"
            style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #cbd5e1', minWidth: 220 }}
          />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span style={{ fontSize: 13, color: '#475569' }}>Mô tả (tuỳ chọn)</span>
          <input
            value={desc}
            onChange={(ev) => setDesc(ev.target.value)}
            style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #cbd5e1', minWidth: 260 }}
          />
        </label>
        <button type="submit" disabled={saving} className="btn-primary">
          {saving ? 'Đang lưu…' : 'Thêm dự án'}
        </button>
      </form>
      )}
      <table
        border="1"
        cellPadding={8}
        style={{ width: '100%', marginTop: canManageProjects ? 8 : 16, borderCollapse: 'collapse' }}
      >
        <thead style={{ background: '#f1f5f9' }}>
          <tr>
            <th align="left">Tên dự án</th>
            <th>Đội</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {projects.map((p) => (
            <tr key={p.id}>
              <td>
                <strong>{p.name}</strong>
                {p.description ? (
                  <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>{p.description}</div>
                ) : null}
              </td>
              <td align="center">{p.team_count ?? '—'}</td>
              <td>
                <Link to={`/projects/${p.id}`}>Chi tiết & đội</Link>
                {' · '}
                <Link to={`/gantt?project=${p.id}`}>Gantt</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {projects.length === 0 && !err && (
        <p style={{ marginTop: 16 }}>
          {canManageProjects
            ? 'Chưa có dự án — thêm bằng biểu mẫu phía trên.'
            : 'Chưa có dự án trong hệ thống. Liên hệ quản trị công ty.'}
        </p>
      )}
    </div>
  );
};

export default ProjectListPage;
